import { JobPostingEmploymentType, JobPostingPayDisplay, JobPostingPayRate, JobPostingPayType } from "@/gql/graphql"
import { PostAJobModalFormValues } from "./types"

export const JOB_TYPES = [
  {
    label: "Paid gig",
    value: JobPostingEmploymentType.Contractor,
  },
  {
    label: "Full-time",
    value: JobPostingEmploymentType.FullTime,
  },
  {
    label: "Part-time",
    value: JobPostingEmploymentType.PartTime,
  },
]

export const PAY_TYPES = [
  {
    label: "Fixed",
    value: JobPostingPayType.FixedFee,
  },
  {
    label: "Range",
    value: JobPostingPayType.RateBased,
  },
]

export const POST_A_JOB_MODAL_DEFAULT_VALUES: PostAJobModalFormValues = {
  title: "",
  jobPostingId: "",
  position: {
    value: "",
    display: "",
  },
  workType: {
    value: "",
    display: "",
    indefiniteArticle: "",
  },
  location: {
    name: "",
    lat: "",
    lon: "",
  },
  referenceImage: {
    file: "",
    name: "",
    existingImageUrl: "",
    existingPosterId: "",
  },
  skillsInputValue: "",
  skills: [],
  description: "",
  remote: false,
  startDate: undefined,
  endDate: undefined,
  jobType: JobPostingEmploymentType.Contractor,
  datesFlexible: false,
  payType: JobPostingPayType.FixedFee,
  rateFrequency: undefined,
  budgetCurrency: "USD",
  payDisplay: JobPostingPayDisplay.Exact,
  budgetAmount: {
    display: "",
    value: null,
  },
  budgetMaxAmount: {
    display: "",
    value: null,
  },
  rateCurrency: "USD",
}
